import { RdoStatusEnum, RdoTableRow } from "./rdoOperacoes.types";

export type RdoPeriodoStatusSummary = {
  inProgress: number;
  emDia: number;
  emAtencao: number;
  atrasadas: number;
};

/** Conta Status só nas linhas consolidadas da classe (US-04 / RN07). */
export function summarizeRdoPeriodoStatus(
  rows: RdoTableRow[]
): RdoPeriodoStatusSummary {
  let emDia = 0;
  let emAtencao = 0;
  let atrasadas = 0;

  for (const row of rows) {
    if (!row.isParent) continue;
    if (row.status === RdoStatusEnum.EmDia) emDia += 1;
    else if (row.status === RdoStatusEnum.EmAtencao) emAtencao += 1;
    else if (row.status === RdoStatusEnum.Atrasada) atrasadas += 1;
  }

  return {
    inProgress: emDia + emAtencao + atrasadas,
    emDia,
    emAtencao,
    atrasadas,
  };
}
